export enum MapElementType {
  Address = "address",
  FavoriteChargingStation = "favoriteChargingstation",
  DisabledChargingStation = "disabledChargingstation",
  Chargingstation = "chargingstation",
  RouteHistory = "routeHistory"
}
